import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import classNames from "classnames";
import SearchIcon from "@/assets/svgs/search.svg";
import { CloseIcon } from "@/assets/svgs/icons";


export interface SearchBarRef {
    setValue: (value: string) => void;
}

interface SearchBarProps {
    lg?: boolean;
    width?: number;
    defaultValue?: string;
    placeholder?: string;
    className?: string;
    onKeyDown?: (e: React.KeyboardEvent) => void;
    onInput?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSearch?: (query: string) => void | Promise<void>;
}

const SearchBar = forwardRef<SearchBarRef, SearchBarProps>((props, ref) => {
    const {
        lg,
        width,
        placeholder,
        defaultValue,
        className: propsClassName,
        onKeyDown,
        onInput,
        onSearch
    } = props;

    const [searched, setSearched] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const search = (value: string) => {
        if (onSearch) {
            onSearch(value);
        }
        setSearched(!!value);
    };

    const onClickClear = () => {
        if (inputRef.current) {
            inputRef.current.value = "";
            setSearched(false);
        }
    };

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        search(inputRef.current?.value ?? "");
    };

    useImperativeHandle(ref, () => ({
        setValue: (value: string) => {
            if (inputRef.current) {
                inputRef.current.value = value;
            }
        }
    }));

    return (
        <form className="relative"
              style={{ width: width ?? "100%" }}
              onSubmit={onSubmit}
        >
            <input type="search"
                   ref={inputRef}
                   defaultValue={defaultValue}
                   placeholder={placeholder}
                   className={classNames(
                       lg ? "input-search" : "input-search-sm",
                       "pl-3.5",
                       searched && "searched",
                       propsClassName
                   )}
                   onKeyDown={onKeyDown}
                   onInput={onInput}
            />
            <span className={classNames(
                      "absolute search-icon right-2.5",
                      lg ? "top-3" : "top-2"
                  )}
            >
                <img src={SearchIcon} alt="" className="size-4" />
            </span>
            <button type="button" 
                    className={classNames(
                        "absolute input-search-cancel-button right-2.5",
                        lg ? "top-3" : "top-2"
                    )}
                    onClick={onClickClear}
            >
                <CloseIcon className="size-4" />
            </button>
        </form>
    );
});

export default SearchBar;
